import { render, staticRenderFns } from "./OrderInfoModal.vue?vue&type=template&id=149a83b0&scoped=true&"
import script from "./OrderInfoModal.vue?vue&type=script&lang=js&"
export * from "./OrderInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoModal.vue?vue&type=style&index=0&id=149a83b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a83b0",
  null
  
)

export default component.exports